import { render, staticRenderFns } from "./sheet.vue?vue&type=template&id=267830f8&scoped=true&"
import script from "./sheet.vue?vue&type=script&lang=js&"
export * from "./sheet.vue?vue&type=script&lang=js&"
import style0 from "./sheet.vue?vue&type=style&index=0&id=267830f8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267830f8",
  null
  
)

export default component.exports